angular.module('impactx.item').directive('ixItemTooltipTable', function() {
    return {
        scope: {
            items: "=",
            deniedItems: "=",
            showNet: "=",
            showGross: "=",
            showCatalogNet: "=",
            trns: "=",
            showExtended: "=?",
            showAat: "=?",
            showControl: "=?"
        },
        restrict: 'E',
        templateUrl: 'shared/item/templates/itemtooltiptable.html'
    };
});